<template>
  <div class="main-box">
    <div class="hot-box">
      <div class="hot-title">
        <span>热门平台</span>
      </div>

      <div class="hot-list">
        <el-link
          :underline="false"
          v-for="(item, index) of hotList"
          :key="index"
          :href="'/enterprise/#/Inside?name=' + item.name"
          target="_blank"
        >
          <div class="hot-plat">
            <div class="hot-logo">
              <img :src="item.a104" />
            </div>

            <div class="hot-con">
              <span class="hot">{{ item.name }}</span>
              <p>{{ item.a103 }}</p>
            </div>
          </div>
        </el-link>
        <el-link href="https://www.hexiaoxiang.com" target="_blank">
          <div class="hot-plat">
            <div class="hot-logo">
              <img
                src="https://qccdata.qichacha.com/GroupImage/m276fe9ae865c71d90444794be036689.jpg"
              />
            </div>

            <div class="hot-con">
              <span class="hot">河小象</span>
              <p>
                河小象是一家互联网写字教育机构，通过精心编排的日课和周课，系统训练小学生的识字写字、阅读及作文能力，提高语文综合素养。
              </p>
            </div>
          </div>
        </el-link>
      </div>
    </div>

    <ul class="main">
      <li class="main-l">
        <!-- <div class="top-img">
          <a
            href="https://www.chinaacc.com/zhuanti/618/"
            target="_blank"
          >
            <img src="https://www.100ec.cn/Public/home/images/jygg/960.jpg?v=1.0" />
          </a>
        </div> -->
        <!-- <div class="top-img">
          <a href="https://www.100ec.cn/zt/hlwyhzzs/">
            <img
              src="https://www.100ec.cn/Public/home/images/ztimg/960.gif"
              target="_blank"
            />
          </a>
        </div> -->
        <div class="platform" v-for="(i, index) of platform" :key="index">
          <div class="platform-title">
            <span :id="i.id">{{ i.title }}</span>

            <el-link
              :underline="false"
              :href="
                '/enterprise/#/list?field=%E5%9C%A8%E7%BA%BF%E6%95%99%E8%82%B2&category=' +
                i.title
              "
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of i.list.slice(0, 6)"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>
      </li>

      <li class="main-r">
        <div class="right-box">
          <div class="right-title">
            <h1>
              <i class="el-icon-star-on" style="color: #e6a23c"></i>口碑榜
            </h1>

            <el-link
              :underline="false"
              href="/Index/complaintData.html?main=3&sub=11"
              target="_blank"
            >
              更多></el-link
            >
          </div>

          <div class="load-box" v-loading="loading3">
            <ul class="pjb">
              <li v-for="(item, index) in tableData.slice(0, 19)" :key="index">
                <a
                  :href="'/Index/complaintDataDetail.html?website=' + item.name"
                  target="_blank"
                >
                  <span>{{ item.name }}</span>
                  <span>{{ item.buy }}</span>
                </a>
              </li>

              <div class="pjb-con">
                <div class="pjb-tab pjb-title">
                  <!-- <span>平台名称</span> -->
                  <span>反馈率</span>
                  <span>时效性</span>
                  <span>满意度</span>
                  <!-- <span>综合指数</span> -->
                  <span>评级</span>
                </div>

                <div
                  class="pjb-tab"
                  v-for="(pj, index) in tableData"
                  :key="index"
                >
                  <!-- <span>{{pj.name}}</span> -->
                  <span>{{ pj.pre }}</span>
                  <span>{{ pj.feedback }}</span>
                  <span>{{ pj.score_ave }}</span>
                  <!-- <span>{{pj.buy}}</span> -->
                  <span>{{ pj.grade }}</span>
                </div>
              </div>
            </ul>
          </div>
        </div>

        <div class="right-box">
          <div class="right-title">
            <h1>
              <i class="el-icon-s-flag" style="color: #67c23a"></i
              ><el-link
                style="font-size: 20px"
                href="/education/#/complainList"
                target="_blank"
                >投诉榜</el-link
              >
            </h1>

            <el-link
              :underline="false"
              href="/Index/complain.html"
              target="_blank"
            >
              我要投诉></el-link
            >
          </div>

          <div class="load-box" v-loading="loading2">
            <div class="tsb">
              <a
                v-for="(item, index) of tsb"
                :key="index"
                :href="'/Index/complain_search.html?company=' + item.company"
                target="_blank"
              >
                <span>{{ index + 1 }}</span>
                <p>{{ item.company }}</p>
              </a>
            </div>
          </div>
        </div>

        <!-- <div class="right-box">
          <a
            href="https://www.med66.com/zhuanti/20230618/index.shtml"
            target="_blank"
          >
            <img
              style="width: 100%"
              src="https://www.100ec.cn/Public/home/images/jygg/550.jpg?v=1.0"
            />
          </a>
        </div> -->

        <div class="right-box">
          <div class="right-title">
            <h1>
              <i class="el-icon-message-solid" style="color: #409eff"></i
              >热点资讯
            </h1>

            <el-link
              :underline="false"
              href="http://edu.100ec.cn/"
              target="_blank"
            >
              更多></el-link
            >
          </div>

          <div class="load-box" v-loading="loading1">
            <el-tabs type="card" @tab-click="getInformation">
              <el-tab-pane
                v-for="(item, index) in tabs"
                :key="index"
                :label="item.label"
              >
                <ul class="zx-list">
                  <li v-for="(i, index) in information" :key="index">
                    <a :href="'/detail--' + i.id + '.html'" target="_blank">
                      {{ i.title }}</a
                    >

                    <!-- <p>{{i.post_date.split(/T|Z/).join(' ').slice(0, 10)}}</p> -->
                  </li>
                </ul>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Main",
  data() {
    return {
      hotList: [
        {
          name: "猿辅导",
          a103: "猿辅导是一个课程在线辅导平台，课程包括系统班、专题课和1对1直播课程等，涵盖小学英语、奥数和初中高中全学科，设有大数据分析系统，可结合海量学生数据了解学生的学习情况，分析学生薄弱点，智能挑选题目",
          a104: "https://qccdata.qichacha.com/GroupImage/m197bc1c816eb910d4b65fd2d8b8d8eb.jpg",
        },
        {
          name: "火花思维",
          a103: "火花思维是一家3-9岁儿童数学在线教育平台，为3-9岁儿童提供数理逻辑、专注力等视频互动课程。全面提高数理逻辑和专注力，隶属于北京心更远科技发展有限公司。",
          a104: "https://qccdata.qichacha.com/GroupImage/mc76099adb09b116b39f9afec40c8771.jpg",
        },
        {
          name: "环球网校",
          a103: "环球网校是一家专注于职业项目培训的在线教育平台，培训的内容包括学习建筑学、建筑工程、医学、金融、会计等。",
          a104: "https://www.100ec.cn/Public/Upload/image/20210312/1615526784698118.png",
        },
        {
          name: "正保远程教育",
          a103: "正保远程教育，自成立以来，一直专注于职业教育和服务，以构建完善的“终身教育体系”和“完全教育体系”为发展战略，牢固树立“学员利益至上，一切为学员服务”的理念",
          a104: "https://www.100ec.cn/Public/Upload/file/20220302/1646212950178630.jpg",
        },
        {
          name: "嗨学网",
          a103: "嗨学网是一家在线职业教育培训平台，针对不同职业人群，提供一级建造师、二级建造师、注册会计师、会计证、会计职称、自考、司法考试等各类网上培训课程产品，同时提供课程答疑等服务。",
          a104: "https://www.100ec.cn/Public/Upload/image/20210312/1615525734760954.png",
        },
      ],
      loading1: false,
      loading2: false,
      loading3: false,
      activeName: "1",
      tabs: [
        {
          value: "15",
          label: "在线教育",
        },
        {
          value: "K12",
          label: "K12",
        },
        {
          value: "AI教育",
          label: "AI教育",
        },
        {
          value: "职业教育",
          label: "职业教育",
        },
        {
          value: "早教",
          label: "早教",
        },
        {
          value: "在线英语",
          label: "在线英语",
        },
        {
          value: "数理思维",
          label: "数理思维",
        },
        {
          value: "编程",
          label: "在线编程",
        },
        {
          value: "高等教育",
          label: "高等教育",
        },
        {
          value: "OMO",
          label: "OMO",
        },
        {
          value: "大班课",
          label: "大班课",
        },
        {
          value: "小班课",
          label: "小班课",
        },
        {
          value: "1v1",
          label: "1v1",
        },
      ],
      information: [],
      complaints: [],
      tsb: [],
      parameter2: {},
      tableData: [],
      parameter: {
        p: 1,
        pagesize: 24,
        a100: "在线教育",
        a102: "",
      },
      platform: [
        {
          title: "综合",
          id: "zh",
          list: [],
        },
        {
          title: "职业教育",
          id: "zyjy",
          list: [],
        },
        {
          title: "早教",
          id: "zj",
          list: [],
        },
        {
          title: "语言类",
          id: "yyl",
          list: [],
        },
        {
          title: "高等教育",
          id: "gdjy",
          list: [],
        },
        {
          title: "steam教育",
          id: "steam",
          list: [],
        },
        {
          title: "K12",
          id: "k12",
          list: [],
        },
        {
          title: "教育服务商",
          id: "jyfws",
          list: [],
        },
      ],
    };
  },
  created() {
    this.getInformation({ label: "在线教育" });
    // this.getComplaints()
    if (new Date().getMonth >= 2) {
      this.parameter2 = {
        type: 11,
        year: new Date().getFullYear(),
      };
    } else {
      this.parameter2 = {
        type: 7,
        year: new Date().getFullYear() - 1,
        time: "whole_year",
      };
    }
    this.getTsb();
    this.getPlatform();
    this.getRating();
  },
  methods: {
    getInformation(key) {
      this.loading1 = true;
      if (key.label == "在线教育") {
        this.$axios.get("/searchjsonb.html?p=1&n=8&terms=5").then((res) => {
          this.information = res.data.list;
        });
      } else {
        this.tabs.forEach((item) => {
          if (item.label == key.label) {
            this.$axios
              .get("/searchjson.html?p=1&n=8&terms=" + item.value)
              .then((res) => {
                this.information = res.data.list;
              });
          }
        });
      }
      this.loading1 = false;
    },
    getTsb() {
      this.loading2 = true;
      this.$axios
        .get(
          "https://www.100ec.cn/315/api/index.php?_a=product&f=most_company_list&type=7&limit=&year=" +
            this.parameter2.year +
            "&time=" +
            this.parameter2.time
        )
        .then((res) => {
          this.tsb = res.data.list.slice(0, 10);
          this.loading2 = false;
        });
    },
    getRating() {
      this.loading3 = true;
      this.$axios({
        method: "post",
        url: "https://www.100ec.cn/315/api/index.php?_a=data",
        data: this.parameter2,
      }).then((res) => {
        for (var i of res.data.list.slice(0, 22)) {
          this.tableData.push({
            name: i.company,
            pre: i.pre,
            feedback: i.feedback,
            score_ave: i.score_ave,
            buy: i.buy,
            grade: i.if_green == 0 && i.buy == 0 ? "不予评级" : i.grade,
          });
        }
        this.loading3 = false;
      });
    },
    getPlatform() {
      for (var i of this.platform) {
        this.parameter.a102 = i.title;
        this.$axios({
          method: "post",
          url: "/Index/new_data_json?dataid=13",
          data: this.parameter,
        }).then((res) => {
          this.platform.forEach((item) => {
            if (item.title == res.data.list[0].a102) {
              item.list = res.data.list;
            }
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.main-box {
  max-width: 1300px;
  margin: 0 auto 40px auto;
}

/* 平台推荐 */
.hot-box {
  background: #fff;
  margin: -38px 0 30px;
  zoom: 1;
}

.hot-title {
  text-align: center;
  border-bottom: 1px solid #f1f4f9;
  padding: 10px 30px;
}

.hot-title span {
  font-size: 24px;
  color: #333;
  line-height: 50px;
  letter-spacing: 5px;
}

.hot-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.hot-list .el-link {
  /* flex: 0 0 18%; */
  display: flex;
  justify-content: left;
  padding: 1%;
  transition: all 0.5s ease-in-out;
}

.hot-list .el-link:hover {
  background: #0e7a63;
  box-shadow: 0 0 5px #0e7a63, 0 0 25px #0e7a63, 0 0 50px #0e7a63,
    0 0 200px #0e7a63;
  -webkit-box-reflect: below 1px linear-gradient(transparent, #0005);
}

.hot-plat {
  display: flex;
}

.hot-logo {
  width: 50px;
  height: 50px;
  border-radius: 0.1rem;
  overflow: hidden;
}

.hot-logo img {
  width: 100%;
  height: 100%;
}

.hot-con {
  flex: 1;
  padding-left: 10px;
}

.hot-con span {
  font-size: 18px;
  font-weight: bold;
  color: #0e7a63;
  transition: all 0.5s ease-in-out;
}

.hot-list .el-link:hover span {
  color: #fff;
}

.hot-con p {
  font-size: 12px;
  color: #888;
  width: 110px;
  height: 3em;
  line-height: 1.5em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 5px;
  transition: all 0.5s ease-in-out;
}

.hot-list .el-link:hover p {
  color: #ccc;
}

.hot {
  position: relative;
  font-size: 18px;
  color: #5c5be3;
}

.hot::after {
  content: "";
  width: 20px;
  height: 20px;
  background: url("/Public/home/images/huo.png");
  background-size: cover;
  position: absolute;
  top: calc(50% - 12px);
  right: -20px;
}

/*  */
.main {
  display: flex;
  justify-content: space-between;
}

.main-l {
  flex: 1;
  margin-right: 20px;
  /* height:400px;
  overflow-y:scroll; */
}

.main-r {
  width: 320px;
}

.platform {
  background: #fff;
  border-radius: 10px;
}

.platform-title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f1f4f9;
  padding: 10px 30px;
}

.platform-title span {
  font-size: 24px;
  color: #0e7a63;
  line-height: 50px;
  position: relative;
  padding-left: 18px;
}

.platform-title span::before {
  content: "";
  width: 4px;
  height: 18px;
  background-color: #0e7a63;
  position: absolute;
  top: calc(50% - 12px);
  left: 0px;
}

.platform-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0 15px;
  margin: 10px 0 30px;
}

.platform-list .el-link {
  flex: 0 0 23%;
  justify-content: left;
  padding: 1%;
}

.platform-list img {
  width: 100%;
}

.plat-box {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  transition: all 0.5s ease-in-out;
}

.plat-box:hover {
  background: #f2f8fd;
}

.plat-logo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}

.plat-logo img {
  width: 100%;
  height: 100%;
}

.plat-con {
  width: 190px;
  padding-left: 10px;
}

.plat-con span {
  font-weight: bold;
  color: #333;
  transition: all 0.5s ease-in-out;
}

.plat-box:hover span {
  color: #0e7a63;
}

.plat-con p {
  font-size: 12px;
  color: #888;
  height: 3em;
  line-height: 1.5em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 5px;
}

/* 右边布局 */
.right-box {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 20px;
}

.load-box {
  min-height: 200px;
  padding: 10px 20px;
}

.right-title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f1f4f9;
  padding: 10px 30px;
}

.right-title h1 {
  font-size: 20px;
  line-height: 50px;
}

.right-title i {
  font-size: 20px;
  padding-right: 5px;
}

/* 资讯 */
.zx-list li {
  display: flex;
  font-size: 14px;
  color: #555;
  line-height: 40px;
  position: relative;
  padding-left: 2%;
}

.zx-list li::before {
  content: "";
  width: 6px;
  height: 6px;
  background: #0e7a63;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: calc(50% - 3px);
}

.zx-list li:hover a {
  color: #0e7a63;
}

.zx-list li a {
  font-size: 14px;
  color: #555;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-left: 10px;
  transition: all 0.5s ease-in-out;
}

.zx-list li p {
  color: #888;
}

/* 投诉榜 */
.tsb a {
  display: flex;
  line-height: 40px;
  margin: 10px 0;
  transition: all 0.5s ease-in-out;
}

.tsb span {
  width: 50px;
  font-family: Impact;
  font-size: 2rem;
  color: #000;
  opacity: 0.25;
  margin: 0 20px;
  transition: all 0.5s ease-in-out;
}

.tsb p {
  width: 180px;
  font-size: 20px;
  color: #333;
  letter-spacing: 2px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}

.tsb a:nth-child(1) p,
.tsb a:nth-child(1) span {
  color: crimson;
  opacity: 1;
}
.tsb a:nth-child(2) p,
.tsb a:nth-child(2) span {
  color: darkorange;
  opacity: 1;
}
.tsb a:nth-child(3) p,
.tsb a:nth-child(3) span {
  color: darksalmon;
  opacity: 1;
}

.tsb a:hover span {
  color: #0e7a63;
  opacity: 1;
  margin-right: 30px;
}

.tsb a:hover p {
  color: #0e7a63;
}

/* 评级榜 */
.pjb {
  position: relative;
}

.pjb li {
  line-height: 50px;
  background: #fafafa;
  border-radius: 2rem;
  padding: 0 20px;
  margin-bottom: 10px;
  transition: all 0.5s ease-in-out;
}

.pjb li:nth-child(1) {
  background: #dc143c !important;
}

.pjb li:nth-child(2) {
  background: #ff8c00 !important;
}

.pjb li:nth-child(3) {
  background: #e9967a !important;
}

.pjb li:hover {
  border-radius: 0;
}

.pjb li a {
  display: flex;
  justify-content: space-between;
  color: #555;
}

.pjb li:nth-child(1) a,
.pjb li:nth-child(2) a,
.pjb li:nth-child(3) a {
  color: #fff;
}

.pjb li span {
  font-size: 20px;
}

.pjb-con {
  width: 350px;
  height: 570px;
  background: #fff;
  opacity: 0;
  position: absolute;
  top: -80px;
  right: 240px;
  z-index: -1;
  transition: all 0.5s ease-in-out;
}

.pjb:hover .pjb-con {
  opacity: 1;
  box-shadow: -5px 0 5px #eee;
  right: 260px;
  z-index: 100;
}

.pjb-tab {
  display: flex;
  justify-content: space-between;
  background: #fafafa;
  line-height: 50px;
  padding: 0 20px;
  margin-bottom: 10px;
}

.pjb-con .pjb-tab:nth-child(2) {
  background: #dc143c;
}

.pjb-con .pjb-tab:nth-child(3) {
  background: #ff8c00;
}

.pjb-con .pjb-tab:nth-child(4) {
  background: #e9967a;
}

.pjb-con .pjb-tab:nth-child(2),
.pjb-con .pjb-tab:nth-child(3),
.pjb-con .pjb-tab:nth-child(4) {
  color: #fff;
}

.pjb-title {
  padding: 10px 20px;
}

.pjb-title span {
  font-weight: bold;
}

.pjb-tab span {
  flex: 0 0 25%;
  font-size: 14px;
}
.top-img {
  margin-bottom: 10px;
}
@media (max-width: 1100px) {
  .top-img img {
    width: 100%;
  }
  .main-box {
    margin: 0 auto 0px auto;
  }
  .hot-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .hot-list .el-link {
    display: flex;
    justify-content: left;
    padding: 0;
    margin: 4px;
    transition: all 0.5s ease-in-out;
  }
  .hot-con span {
    font-size: 16px;
    font-weight: 700;
    color: #0e7a63;
    transition: all 0.5s ease-in-out;
  }
  .main {
    width: 100%;
    display: block;
  }
  .main-l {
    width: 100%;
    flex: 1;
    margin: 0;
    /* margin-right: 20px; */
  }
  .main-r {
    /* display: none; */
    width: 100%;
  }
  .load-box {
    height: 340px;
    overflow: hidden;
    min-height: 200px;
    padding: 10px 20px;
  }
  .platform-list {
    display: flex;
    flex-wrap: wrap;
    height: 400px;
    overflow: hidden;
    padding: 0 15px;
    margin: 10px 0 20px;
  }
  .platform-list .el-link {
    flex: 0 0 23%;
    justify-content: left;
    padding: 0;
  }
  .load-box {
    height: 350px;
    overflow: hidden;
    min-height: 200px;
    padding: 10px 20px;
  }
  .plat-con p {
    width: 270px;
  }
}
</style>